
import {
  ActivimeterCalibrationDto,
  CreateActivimeterCalibrationDto,
  UpdateActivimeterCalibrationDto,
} from './dtos'
import { BaseCrudService } from './BaseCrudService'
import { PaginatedQueryBase } from './api'

export type ActivimeterCalibrationsFilters = PaginatedQueryBase & {
  includeInactive?: boolean
}

class ActivimeterCalibrationService extends BaseCrudService<
  ActivimeterCalibrationDto,
  CreateActivimeterCalibrationDto,
  UpdateActivimeterCalibrationDto,
  ActivimeterCalibrationsFilters
> {
  constructor() {
    super('activimeter-calibration', process.env.REACT_APP_RADIOPHARMACY_API_URL)
  }
}

export const activimeterCalibrationService = new ActivimeterCalibrationService()
